import React, { useState } from 'react';
import { toast } from 'sonner';
import { Check, Copy } from 'lucide-react';

export const Panel = ({ children, className = '', testId }) => (
  <section className={`rounded-xl border border-slate-200 bg-white shadow-sm ${className}`} data-testid={testId}>{children}</section>
);

const claseCampo = 'mt-1 w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-base text-slate-800 outline-none transition-[border-color,box-shadow] focus:border-emerald-700 focus:ring-2 focus:ring-emerald-700/20 sm:text-sm';

export const CampoTexto = ({ label, ayuda, value, onChange, testId, multiline = false, ...rest }) => (
  <label className="block">
    <span className="text-sm font-medium text-slate-700">{label}</span>
    {multiline
      ? <textarea rows={3} value={value} onChange={e => onChange(e.target.value)} className={claseCampo} data-testid={testId} {...rest} />
      : <input value={value} onChange={e => onChange(e.target.value)} className={claseCampo} data-testid={testId} {...rest} />}
    {ayuda && <span className="mt-1 block text-xs text-slate-500">{ayuda}</span>}
  </label>
);

export const CampoSelect = ({ label, value, onChange, opciones, testId }) => (
  <label className="block">
    <span className="text-sm font-medium text-slate-700">{label}</span>
    <select value={value} onChange={e => onChange(e.target.value)} className={claseCampo} data-testid={testId}>
      {opciones.map(o => <option key={o.valor} value={o.valor}>{o.etiqueta}</option>)}
    </select>
  </label>
);

const copiarTexto = async (texto) => {
  try {
    await navigator.clipboard.writeText(texto);
  } catch (e) {
    const area = Object.assign(document.createElement('textarea'), { value: texto });
    document.body.appendChild(area);
    area.select();
    document.execCommand('copy');
    area.remove();
  }
};

export const BotonCopiar = ({ texto, testId, label = 'Copiar enlace', className = '' }) => {
  const [ok, setOk] = useState(false);
  const copiar = async () => {
    await copiarTexto(texto);
    setOk(true);
    toast.success('Enlace copiado');
    setTimeout(() => setOk(false), 1800);
  };
  return (
    <button type="button" onClick={copiar} data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50 ${className}`}>
      {ok ? <Check className="h-4 w-4 text-emerald-600" /> : <Copy className="h-4 w-4" />}{label}
    </button>
  );
};

export const Vacio = ({ children, testId }) => (
  <p className="px-6 py-12 text-center text-slate-500" data-testid={testId}>{children}</p>
);
